import oldage from '../Images/oldage.svg';
import care from '../Images/care.svg'
import home from '../Images/home.svg'
import rehab from '../Images/rehab.svg'
import postoperative from '../Images/postoperative.svg'
import assistedcare from '../Images/assistedcare.svg'
export const MyFeatures = [
    {
        "id": "001",
        "title": "Rehabilitation",
        "description": "",
        "img": rehab
    },    
    {
        "id": "002",
        "title": "Terminal Care",
        "description": "",
        "img": care
    },
    {
        "id": "003",
        "title": "Old Age Home",
        "description": "",
        "img": home
    },
    {
        "id": "004",
        "title": "Geriatric Care",
        "description": "",
        "img": oldage
    },    
    {
        "id": "005",
        "title": "Post Operative care",
        "description": "",
        "img": postoperative
    },
    {
        "id": "006",
        "title": "Assisted Care",
        "description": "",
        "img": assistedcare
    }     
]


